import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum DateFilterByTypes {
  ENTRY = 'ENTRY',
  AUTHORIZATION = 'AUTHORIZATION',
  CLOSING = 'CLOSING',
  LEAVE = 'LEAVE',
  RETURN = 'RETURN',
}

export const DateFilterByMap: Record<number, DateFilterByTypes> = {
  0: DateFilterByTypes.ENTRY,
  1: DateFilterByTypes.AUTHORIZATION,
  2: DateFilterByTypes.CLOSING,
  3: DateFilterByTypes.LEAVE,
  4: DateFilterByTypes.RETURN,
};

export enum ReportSourceTypes {
  WORK_ORDER = 'WORK_ORDER',
  DIRECT_SALE = 'DIRECT_SALE',
  COMBINED = 'COMBINED',
}

export enum ClassificationTypes {
  QUANTITY = 'QUANTITY',
  VALUE = 'VALUE',
}

export enum FormatType {
  PDF = 'PDF',
  CSV = 'CSV',
}

export enum SituationsType {
  OPEN = 'OPEN',
  AUTHORIZED = 'AUTHORIZED',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
}

export enum WorkOrderType {
  COURTESY = 'COURTESY',
  WARRANTY = 'WARRANTY',
  WORK_ORDER = 'WORK_ORDER',
  TOTAL_LOSS = 'TOTAL_LOSS',
  RETURN = 'RETURN',
  REVISION = 'REVISION',
}

export interface AbcCurveRequest {
  classificationType: ClassificationTypes;
  companiesIds?: string;
  dateFilterType?: DateFilterByTypes;
  endDate?: string;
  format: FormatType;
  parts: boolean;
  reportSource: ReportSourceTypes;
  services: boolean;
  situations: SituationsType;
  startDate?: string;
  suppliedParts: boolean;
  thirdParty: boolean;
  workOrderTypes: WorkOrderType;
}

export interface AbcCurveFormValues extends ReportDateInterface {
  classificationType: ClassificationTypes;
  filterDateBy: DateFilterByTypes;
  format: FormatType;
  parts: boolean;
  reportSource: ReportSourceTypes;
  services: boolean;
  situations: SituationsType;
  suppliedParts: boolean;
  thirdParty: boolean;
  workOrderTypes: WorkOrderType;
}
